import { getCapitalFirstLetter } from './get-capital-first-latter';
export var capitalizeFirstLetter = function (value) { return getCapitalFirstLetter(value) + value.slice(1); };
